export default {
    bannerOpen: {
        marginTop: '40px'
    },
    boxContainer: {
        border: '1px black',
    },
    button: {
        '&.MuiButton-root': {
            borderRadius: '4px',
            boxSizing: 'border-box',
            boxShadow: 'none',
            fontSize: '16px',
            height: '40px',
            letterSpacing: '0.5px',
            marginBottom: '15px',
            minWidth: '80px'
        }
    },
    centralLoginBox: {
        '@media screen and (max-width: 380px)': {
            marginTop: '0px'
        },
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        minHeight: '100vh',
        paddingBottom: '39px',
        paddingTop: '48px'
    },
    checkbox: {
        '& .MuiSvgIcon-root': { fontSize: '18px' }
    },
    defaultCursor: {
        cursor: 'default'
    },
    emailContainer: {
        paddingTop: '13px',
        marginBottom: '30px'
    },
    forgotPassword: {
        alignSelf: 'start',
        display: 'flex',
        fontSize: '14px'
    },
    forgotPwdResponse: {
        fontSize: '14px',
        margin: '5px 0 15px 0'
    },
    forgotPasswordMsg: {
        color: theme => theme.palette.error.main
    },
    forgotPasswordSuccessMsg: {
        color: theme => theme.palette.success.main
    },
    header: {
        color: '#006AC3',
        fontFamily: 'Roboto',
        fontSize: '32px',
        fontWeight: '500',
        letterSpacing: '0',
        lineHeight: '32px'
    },
    headerDivider: {
        backgroundColor: '#FFC72C',
        height: '3px',
        margin: '12px 0px 12px 0',
        width: '40px'
    },
    innerOr: {
        background: '#ffffff',
        color: '#5B6169',
        fontFamily: 'Roboto',
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: '-10px',
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '35px'
    },
    input: {
        minHeight: '22px'
    },
    languageButton: {
        '@media screen and (min-width: 767px)': {
            display: 'none',
        },
        color: 'rgb(0, 81, 165)',
        float: 'right',
        fontSize: '10px',
        width: '35%',
        marginLeft: '65%'
    },
    linearProgressLogin: {
        left: '0',
        position: 'fixed',
        top: '0',
        width: '100%',
        zIndex: '-1'
    },
    linearProgressMfa: {
        left: '0',
        position: 'fixed',
        top: '72px',
        width: '100%',
        zIndex: '-1'
    },
    leftContainer: {
        '@media screen and (max-width: 767px)': {
            flexBasis: '100%',
            maxWidth: '100%',
        },
        background: '#FFFFFF',
    },
    loginContainer: {
        display: 'flex',
        minHeight: '100vh',
        padding: '25px 35px 25px 35px'
    },
    loginPage: {
        flex: '1',
        display: 'flex',
        height: '100vh'
    },
    loginPageMata: {
        flex: '1',
        display: 'flex',
        height: '100vh',
        width: '100%'
    },
    loginContainerGrid: {
        display: 'inline'
    },
    logoEn: {
        marginBottom: '40px',
    },
    logoFr: {
        marginBottom: '40px',
    },
    logoContainer: {
        height: '90px'
    },
    logoutIframe: {
        display: 'none'
    },
    moreInfoText: {
        color: '#424242',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: '300',
        lineHeight: '18px',
        margin: '0 0 30px 0'
    },
    orDivider: {
        borderTop: '1px solid #dadada',
        lineHeight: '20px',
        margin: '11px 0 10px 0',
        textAlign: 'center',
        width: '100%'
    },
    rbccmOnlineContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    rememberMeContainer: {
        marginTop: '3px'
    },
    rememberMeLabel: {
        color: '#565656',
        fontFamily: 'Roboto',
        fontSize: '14px',
        lineHeight: '1',
        marginLeft: '3px'
    }
}
